import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SignUpPhone from "./Components/Signup/SignUpPhone/SignUpPhone";
import NumOtp from "./Components/Signup/SignUpPhone/SignUpPhOtp";
import SignUpEmail from "./Components/Signup/SignUpEmail/SignUpEmail";
import EmailNumOtp from "./Components/Signup/SignUpEmail/SignUpEmailOtp";
import PanVerify from "./Components/Signup/PanVerify/PanVerify";
import LinkBankAccount from "./Components/Signup/LinkBankAccount/LinkBankAccount";
import YourDetails from "./Components/Signup/PersonalDetails/YourDetails";
// import AddNominee from "./Components/Signup/Digilocker";
import CaptureSelfie from "./Components/Signup/Selfie/CaptureSelfie";
import CaptureSignature from "./Components/Signup/Signature/CaptureSignature";
import PrivateRoute from "./Components/Signup/PrivateRoute";
// import Home from "./Components/Signup/Home";
// import Products from "./Components/Signup/Products/Products";
import SignUpCongrats from "./Components/Signup/SignUpCongrats/SignUpCongrats";
// import ActivateFnO from "./Components/Signup/ActivateFnO/ActivateFnO";
import Digilockerr from "./Components/Signup/DigiLocker/Digilocker";

import AddNominee from "./Components/Signup/Nominee/AddNominee";
import SignatureMobile from "./Components/Signup/Signature/SignatureMobile";
import CaptureSelfieMobile from "./Components/Signup/Selfie/CaptureSelfieMobile";
import ActivateFnO from "./Components/Signup/ActivateFnO/ActivateFnO";

import MainPlanPage from "./Components/Signup/Products/MainPlansPage";
import AadhaarESign from "./Components/Signup/E_sign/eSign";
import Congrats from "./Components/Signup/Final_Congrats/Final_Congrats";
import DIS from "./Components/Signup/DIS/DisPage";
import Version from "./Version";

import RetakeProtectedRoute from "./Components/RetakeProtectedRoute";
import CaptureRetakeSelfie from "./Components/Signup/Selfie/Retake/CaptureRetakeSelfie";
import CaptureRetakeSelfieMobile from "./Components/Signup/Selfie/Retake/CaptureRetakeSelfieMobile";
import CaptureRetakeSignature from "./Components/Signup/Signature/Reatake/CaptureRetakeSignature";
import SignatureRetakeMobile from "./Components/Signup/Signature/Reatake/SignatureRetakeMobile";
import RetakeNumOtp from "./Components/Signup/SignUpPhone/Retake/RetakeOtpPage";
import GA4PageViewTracker from "./ui-utils.js/GA4PageViewTracker";

import DocumentMeta from 'react-document-meta'
const meta = {
  title: 'Open Demat Account with TradeBoss | Register & Start Trading',
  description: 'Sign up with TradeBoss and open your demat account instantly. Trade stocks, bonds & IPOs securely on India’s trusted NSE, BSE platform.',
  canonical: 'https://kyc.tradeboss.co/',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'open demat account India, register trading account, how to open demat account, online demat account registration, tradeboss registration, KYC demat account, demat account signup'
    }
  }
}
function App() {
  return (
    <BrowserRouter>
      <DocumentMeta {...meta} />
        <GA4PageViewTracker/>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/retake-otp" element={<RetakeProtectedRoute><RetakeNumOtp /></RetakeProtectedRoute>} />
        <Route path="/" element={<SignUpPhone />} />

        {/* Protected routes */}
        <Route
          path="/signupphotp"
          element={
            <PrivateRoute>
              <NumOtp />
            </PrivateRoute>
          }
        />

        <Route
          path="/signupemail"
          element={
            <PrivateRoute>
              <SignUpEmail />
            </PrivateRoute>
          }
        />

        <Route
          path="/signupemailotp"
          element={
            <PrivateRoute>
              <EmailNumOtp />
            </PrivateRoute>
          }
        />

        <Route
          path="/signupcongrats"
          element={
            <PrivateRoute>
              <SignUpCongrats />
            </PrivateRoute>
          }
        />

        {/* Stepper Routes */}
        <Route
          path="/step-1"
          element={
            <PrivateRoute>
              <PanVerify />
            </PrivateRoute>
          }
        />
        <Route path="/step-2" element={<PrivateRoute><Digilockerr /></PrivateRoute>} />
        <Route path="/step-3" element={<PrivateRoute><LinkBankAccount /></PrivateRoute>} />
        <Route path="/step-4" element={<PrivateRoute><ActivateFnO /></PrivateRoute>} />
        <Route path="/step-5" element={<PrivateRoute><YourDetails /></PrivateRoute>} />
        <Route path="/step-6" element={<PrivateRoute><AddNominee /></PrivateRoute>} />
        <Route path="/step-7" element={<PrivateRoute><CaptureSelfie /></PrivateRoute>} />
        <Route path="/step-8" element={<PrivateRoute><CaptureSignature /></PrivateRoute>} />
        <Route path="/selfie-retake" element={<RetakeProtectedRoute><CaptureRetakeSelfie /></RetakeProtectedRoute>}/>
        <Route path="/selfie-mobile-retake" element={<CaptureRetakeSelfieMobile />} />
        <Route path="/signature-retake" element={<RetakeProtectedRoute><CaptureRetakeSignature /></RetakeProtectedRoute>} />
        <Route path="/signature-mobile-retake" element={<SignatureRetakeMobile />} />
               
        {/*dev-Ayush 22-04-2025*/}
        <Route path="/signature-mobile" element={<SignatureMobile/>} />
        <Route path="/selfie-mobile" element={<CaptureSelfieMobile/>} />

        <Route path="/products" element={<PrivateRoute><MainPlanPage /></PrivateRoute>} />

        <Route path="/e_sign" element={<AadhaarESign/>}/>
        <Route path="/final-congrats" element={<Congrats/>}/>
        <Route path="/dis" element={<PrivateRoute><DIS/></PrivateRoute>}/>
        <Route path="/version" element={<Version/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
